// extracted by mini-css-extract-plugin
module.exports = {"sign-in-and-sign-up":"sign-in-and-sign-up_sign-in-and-sign-up__E1bkx"};